import React, { useState } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import SightWordsActivity from '../components/SightWordsActivity';
import ScrambleWordsActivity from '../components/ScrambleWordsActivity';
import CategoryWordsActivity from '../components/CategoryWordsActivity';
import MathConceptsActivity from '../components/MathConceptsActivity';
import DailyLivingActivity from '../components/DailyLivingActivity';
import ProgressTracker from '../components/ProgressTracker';
import AchievementBadges from '../components/AchievementBadges';
import WeeklyProgress from '../components/WeeklyProgress';
import MicrophonePermissionModal from '../components/MicrophonePermissionModal';
import { useUser } from '../context/UserContext';
import { useFeatureFlags } from '../context/FeatureFlagsContext';
import './Dashboard.css';

const Dashboard = () => {
  const { logout, currentUser } = useUser();
  const { flags } = useFeatureFlags();
  const firstName = currentUser?.firstName || currentUser?.username || 'Explorer';
  const [activeView, setActiveView] = useState('sight-words');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const renderActivity = () => {
    switch(activeView) {
      case 'sight-words':
        return <SightWordsActivity onComplete={() => setActiveView('progress')} />;
      case 'scramble':
        return <ScrambleWordsActivity onComplete={() => setActiveView('progress')} />;
      case 'category':
        return <CategoryWordsActivity onComplete={() => setActiveView('progress')} />;
      case 'math':
        return flags.math_concepts_enabled !== false ? <MathConceptsActivity onComplete={() => setActiveView('progress')} /> : <SightWordsActivity onComplete={() => setActiveView('progress')} />;
      case 'daily-living':
        return flags.daily_living_enabled !== false ? <DailyLivingActivity onComplete={() => setActiveView('progress')} /> : <SightWordsActivity onComplete={() => setActiveView('progress')} />;
      case 'progress':
        return <ProgressTracker />;
      case 'achievements':
        return <AchievementBadges />;
      case 'weekly':
        return <WeeklyProgress />;
      default:
        return <SightWordsActivity onComplete={() => setActiveView('progress')} />;
    }
  };

  return (
    <div className="dashboard-page">
      <MicrophonePermissionModal />
      <Header isLoggedIn={true} onLogout={logout} isAdmin={false} onToggleSidebar={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)} />

      <div className="dashboard-layout">
        <Sidebar activeItem={activeView} onItemClick={setActiveView} isMobileOpen={isMobileSidebarOpen} onCloseMobile={() => setIsMobileSidebarOpen(false)} />

        <main className="dashboard-main">
          <div className="welcome-banner">
            <h1>Welcome, {firstName}! 🌟</h1>
            <p>Let's practice some fun activities to improve your skills.</p>
          </div>

          {renderActivity()}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;